var React = require('react');

function U2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"U2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M28.07,84.42A30.36,30.36,0,0,0,56.56,55.48L60.14,1.63,33,.42Z","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M29.7,84.84A30.36,30.36,0,0,1,1.53,55.58L0,.92,27.15,0Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

U2.defaultProps = {"viewBox":"0 0 60.14 84.84"};

module.exports = U2;

U2.default = U2;
